'use client';
import { useEffect } from 'react';

import { Logger } from '@/lib/Logging';

import ErrorPageContent from '@/app/ErrorFile';

const logger = new Logger('src/app/error.tsx handler');
// Error components must be Client Components

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    logger.error(error);
  }, [error]);

  return <ErrorPageContent message='Something went wrong' />;
}
